'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ArrowRight = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React__default.default.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.298 31.768"
}, props), /*#__PURE__*/React__default.default.createElement("path", {
  "data-name": "Path 388",
  d: "M.707.707l15.177 15.177L.707 31.061",
  fill: "none"
})));

exports.default = ArrowRight;
//# sourceMappingURL=arrow_right.inline.svg.js.map
